import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

import EmptyImage from './EmptyImage';

import './styles.scss';

const propTypes = {
    imageOverride: PropTypes.node,
    img: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
};

const AbsoluteEmpty = memo(
    ({
        actions,
        imageOverride,
        img,
        size,
        subtitle = getLiteral('error_generalerror'),
        svg,
        title = getLiteral('label_page_error_title'),
    }) => {
        const theme = useTheme();

        const className = classnames('fm-absolute-empty', {
            'fm-absolute-empty--popover': size === 'popover',
            'fm-absolute-empty--small': size === 'small',
            'fm-absolute-empty--widget': size === 'widget',
        });

        let titleType = size === 'popover' ? 'subtitle1' : 'h6';
        let subtitleType = size === 'popover' ? 'caption' : 'body';

        if (size === 'widget') {
            titleType = 'subtitle1';
            subtitleType = 'caption';
        }

        if (size === 'small') {
            titleType = 'captionMedium';
            subtitleType = 'caption';
        }

        const imageElement = useMemo(() => {
            if (imageOverride) return imageOverride;
            if (svg) return svg;
            if (img) return <img src={img} />;
            return <EmptyImage />;
        }, [imageOverride, svg, img]);

        return (
            <div className={className}>
                {imageElement}
                <Text type={titleType} color={theme.colors.utility.textPrimary}>
                    {title}
                </Text>
                <Text type={subtitleType} color={theme.colors.utility.textSecondary}>
                    {subtitle}
                </Text>
                {actions?.length > 0 && <div className="fm-absolute-empty__actions">{actions}</div>}
            </div>
        );
    },
);

AbsoluteEmpty.propTypes = propTypes;

export default AbsoluteEmpty;
